export enum CurrentPalletStateEnum {
    FREE = 'FREE',
    ONWORK = 'ONWORK',
    
}
